import { STAGE_CONFIG } from "./config/hiringConfig";

export const mapApiToPipeline = (apiData: any[]) => {
    return apiData.map((job) => ({
        title: job.jobTitle,
        totalApplications: job.totalApplications,
        stages: STAGE_CONFIG.map((stage) => ({
            stage: stage.label,
            count: job[stage.key] ?? null,
            color:
                job[stage.key] > 0
                    ? stage.color
                    : "bg-gray-200",
        })),
    }));
};
